import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TEST_SETS_CATEGORY_ORDER, TEST_SETS_COUNT_LIMIT } from "../constants";
import { SheetSelection } from "./components/SheetsSelection";

export function CategorySheetSelection({
  sheetIds,
  sheetsByCategories = {},
  setFieldValue,
  sheetData,
  ...rest
}) {
  const [selectedTab, setSelectedTab] = useState(TEST_SETS_CATEGORY_ORDER[0]);
  const { t } = useTranslation();

  const handleTabChange = (_, newValue) => {
    setSelectedTab(newValue);
  };

  const handleSheetChange = (e, index, category) => {
    const sheetIdValue = e.target.value;
    const categorySheetIds = [...(sheetsByCategories[category] || [])];
    categorySheetIds[index] = sheetIdValue;

    const updatedSheets = categorySheetIds.map(id => id || "");
    const selectedSheetsByCategories = {
      ...sheetsByCategories,
      [category]: updatedSheets,
    };

    const selectedSheetIds = [
      ...new Set(
        Object.values(selectedSheetsByCategories).flat().filter(Boolean)
      ),
    ];

    setFieldValue("sheetsByCategories", selectedSheetsByCategories);
    setFieldValue("sheetIds", selectedSheetIds);
  };

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={selectedTab}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {TEST_SETS_CATEGORY_ORDER.map(category => (
              <Tab
                key={category}
                label={t(`frontend.test.category.${category}`, category)}
                value={category}
              />
            ))}
          </TabList>
        </Box>
        {TEST_SETS_CATEGORY_ORDER.map(category => {
          const categorySheetIds = sheetsByCategories[category] || [];
          const fieldCount =
            category === TEST_SETS_CATEGORY_ORDER[0]
              ? 1
              : TEST_SETS_COUNT_LIMIT;

          return (
            <TabPanel
              key={category}
              value={category}
              sx={{ paddingLeft: 0, paddingRight: 0 }}
            >
              <SheetSelection
                sheetIds={categorySheetIds}
                sheetData={sheetData}
                fieldCount={fieldCount}
                onChange={(e, index) => handleSheetChange(e, index, category)}
                {...rest}
              />
            </TabPanel>
          );
        })}
      </TabContext>
    </Box>
  );
}
